export default __webpack_public_path__ + "static/media/m.6217cfb8.png";